import React from 'react'

import useAxios from 'hooks/useAxios'
import SendingHistory from '.'

/**
 * @param {object} props
 * @param {string} props.surveyToken
 * @param {number} props.surveyId
 */
export default function SendingHistoryContainer({ surveyToken, surveyId }) {
  const { data } = useAxios({
    url: `survey/survey/${surveyToken}/email-delivery-history/`,
  })

  return <SendingHistory history={data} surveyId={surveyId} />
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SendingHistory/container.js